import { SovosPageLayout, SovosPaper, SovosTypography } from "mosaic-react";
import { useNavigate } from "react-router-dom";
import RequestForm from "../components/RequestForm";
import { oseQuery } from "../api/oseQuery";
import CustomTitle from "../components/typography/CustomTitle";

const Home = () => {
  const navigate = useNavigate();
  const handleSubmit = async (formData) => {
    oseQuery(formData)
      .then((response) => {
        navigate("/result", {
          state: { queryResponse: response.data.message },
        });
      })
      .catch((error) => {
        navigate("/result", {
          state: {
            queryResponse: "Lo sentimos, por favor inténtelo más tarde.",
          },
        });
      });
  };
  return (
    <>
      <SovosPageLayout
        pageTitle={
          <CustomTitle
            text={"Consulta de Validez de Comprobante de Pago Electrónico"}
          />
        }
      >
        <SovosPaper
          sx={{
            padding: 1,
            backgroundColor: "#F5F5F5",
            margin: 1,
          }}
        >
          <SovosTypography
            variant="body2"
            sx={{
              padding: "1rem",
            }}
          >
            Señor contribuyente, a través de esta consulta, usted podrá
            consultar la validez de la factura electrónica, la boleta de venta
            electrónica, el DAE, la nota electrónica vinculada y la Guía de
            Remisión Electrónica. Asimismo, podrá consultar si la boleta de
            venta electrónica y/o la nota electrónica vinculada a aquella fueron
            informadas en un resumen diario a través del Sistema de Emisión
            Electrónica - OSE.
          </SovosTypography>
          <SovosTypography
            variant="body2"
            sx={{
              padding: "1rem",
            }}
          >
            Ingrese los siguientes datos que figuran en el CPE:
          </SovosTypography>
          <RequestForm onSubmit={handleSubmit} />
        </SovosPaper>
      </SovosPageLayout>
    </>
  );
};
export default Home;
